import classNames from 'classnames'

import { formatAsTitle } from '@/utils/format'
import Text from '@/elements/Text'
import Flex from '@/elements/Flex'
import { AlertStatuses, type AlertStatusType } from '@/api/types/Alert'

import './StatusCard.scss'

const describedAlertStatuses = AlertStatuses.map((status: AlertStatusType) => {
  switch (status) {
    case 'NEW':
      return { title: formatAsTitle(status), description: 'Newly reported alert' }
    case 'ESCALATED':
      return { title: formatAsTitle(status), description: 'Forward to responsible party' }
    case 'MONITOR':
      return { title: formatAsTitle(status), description: 'Keep watching for further activity' }
    case 'ISSUE_TAKEDOWN':
      return { title: formatAsTitle(status), description: 'Immediate content removal required' }
    case 'RESOLVED':
      return { title: formatAsTitle(status), description: 'Issue has been resolved' }
    default:
      return null
  }
})

interface StatusCardProps {
  status: AlertStatusType | undefined
  selected?: boolean
  onClick?: () => void
}

function StatusCard({
  status,
  selected = true,
  onClick
}: StatusCardProps) {
  if (!status) {
    return null
  }

  const alertStatus = describedAlertStatuses
    .filter((s): s is { title: string; description: string } => s !== null)
    .find(s => s.title === formatAsTitle(status))

  if (!alertStatus) {
    return null
  }

  return (
    <Flex
      wfull
      gap={2} px={3} py={2}
      className={
        classNames(
          'status-card',
          { selected },
          { [`status-card-${status.toLowerCase()}`]: status },
          { 'status-card-clickable': !!onClick }
        )
      }
      onClick={onClick}
    >
      <Text variant='h4' className='status-card-title'>{alertStatus.title}</Text>
      <Text color='black-light-40'>{alertStatus.description}.</Text>
    </Flex>
  )
}

export default StatusCard
